import { BUSINESS_OPTIONS } from '../flow/checkboxOptions';
import { MatcherGenericCheckboxStep } from '../components';

function MatcherBusinessStep() {
  return (
    <MatcherGenericCheckboxStep
      questionId="business"
      title="How can a pro help your business?"
      options={BUSINESS_OPTIONS}
      stepName="matcher_business_step"
      requireSelection={false}
    />
  );
}

export { MatcherBusinessStep };
